export function getNumberedLabel(baseLabel: string, totalCount: number, index: number): string {
  if (totalCount <= 1) return baseLabel;

  return `${baseLabel} (${index + 1})`;
}
